import React, { useContext, useEffect } from "react";
import { FilterContext } from "../FilterContext";
import FilterPopup from "../FilterPopup";
import { initialAirportSizeFilter } from "./FilterTypes/AirportSizeFilterType";
import { Checkbox } from "components/Atoms/inputs/Checkbox";


const AirportSizeFilter = () => {
  const title = RESX.AirportSizeFilter.Size;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("airportSize", {
    getTitle: () => title,
    renderSelection: (value) => value.airportSize === "includeSmaller" && <>{RESX.AirportSizeFilter.IncludeSmallerAirports}</>,
    hasValue: (value) => value.airportSize !== initialAirportSizeFilter.airportSize,
    reset: () => initialAirportSizeFilter,
    areEqual: (a, b) => a.airportSize === b.airportSize
  });
  useEffect(() => {
    setInitialValue("airportSize", initialAirportSizeFilter);
  }, []);

  const [airportSizeFilter, setAirportSizeFilter] = React.useState<server.dto.AirportSizeFilterOptions>(initialAirportSizeFilter.airportSize);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onChange = (isChecked: boolean) => {
    const newValue: server.dto.AirportSizeFilterOptions = isChecked ? "includeSmaller" : "onlyMajor";
    setAirportSizeFilter(newValue);
    setPopupOpen(false);
    setValue("airportSize", {
      airportSize: newValue
    });
  };

  const onPopupClose = () => {
    setPopupOpen(false);
  };

  const onPopupOpen = () => {
    setAirportSizeFilter(getValue("airportSize").airportSize);
    setPopupOpen(true);
  };

  const onApplyFilter = (e?) => {
    e?.preventDefault();
    setValue("airportSize", {
      airportSize: airportSizeFilter
    });
    setPopupOpen(false);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      content={<form onSubmit={onApplyFilter}>
        <Checkbox
          label={RESX.AirportSizeFilter.IncludeSmallerAirports}
          checked={airportSizeFilter === "includeSmaller"}
          onChange={(_, value) => onChange(value)}

        />
      </form>}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default AirportSizeFilter;